<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">{{ $t('partTimeOfMonthly.pageTitle') }}</h1>
			<ts-breadcrumb :items="[
				{ text: $t('toHomePage'), href: '/' },
				{
					text: $t('partTimeOfMonthly.pageTitle'),
					active: true
				}
			]" />
		</div>
		<div class="row">
			<div class="col-md-3">
				<ts-card>
					<ts-card-wrapper>
						<ts-loading-banner :loading="loading">
							<form>
								<fieldset>
									<legend>{{ $t('partTimeOfMonthly.criteria') }}</legend>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
				$t('partTimeOfMonthly.branchName')
			}}</label>
											<a-select style="width:100%" v-model.number="model.branch_id" :options="branches"></a-select>
											<div class="validate" v-if="errors.has('branch_id')">
												{{ errors.first('branch_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
				$t('partTimeOfMonthly.month')
			}}</label>
											<a-select style="width: 100%" v-model="model.cycle_value" :options="scoringCycleValue">
											</a-select>
											<div class="validate" v-if="errors.has('cycle_value')">
												{{ errors.first('cycle_value') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
				$t('partTimeOfMonthly.mainProgram')
			}}</label>
											<a-select style="width: 100%" v-model.number="model.acp_id" :options="main_programs"
												:show-search="true" :filter-option="(input, option) =>
				option.componentOptions.children[0].text
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
				" @change="onMainProgramChange"></a-select>
											<div class="validate" v-if="errors.has('acps_id')">
												{{ errors.first('acps_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
				$t('partTimeOfMonthly.subProgram')
			}}</label>
											<a-select style="width: 100%" v-model.number="model.acps_id" :options="sub_programs"
												:show-search="true" :filter-option="(input, option) =>
				option.componentOptions.children[0].text
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
				" @change="onSubChange" :disabled="!model.acp_id"></a-select>
											<div class="validate" v-if="errors.has('acps_id')">
												{{ errors.first('acps_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
				$t('partTimeOfMonthly.acYear')
			}}</label>
											<a-select style="width: 100%" v-model.number="model.ac_year_id" :options="ac_year_list"
												:loading="fetching_academic_year" @change="acYearChange"></a-select>
											<div class="validate" v-if="errors.has('ac_year_id')">
												{{ errors.first('ac_year_id') }}
											</div>
										</div>
									</div>
									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
				$t('partTimeOfMonthly.acTerm')
			}}</label>
											<a-select style="width: 100%" v-model.number="model.ac_term_id" :options="ac_terms"
												:show-search="true" :loading="fetching_academic_term" :filter-option="(input, option) =>
				option.componentOptions.children[0].text
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
				" @change="acTermChange"></a-select>
											<div class="validate" v-if="errors.has('ac_term_id')">
												{{ errors.first('ac_term_id') }}
											</div>
										</div>
									</div>

									<div class="row form-group">
										<div class="col-md-12">
											<label class="required">{{
				$t('partTimeOfMonthly.classOperation')
			}}</label>
											<a-select style="width: 100%" v-model="model.class_id" :options="classes" :show-search="true"
												:placeholder="$t('all')" :loading="fetching_class_operation" :filter-option="(input, option) =>
				option.componentOptions.children[0].text
					.toLowerCase()
					.indexOf(input.toLowerCase()) >= 0
				"></a-select>
											<div class="validate" v-if="errors.has('class_id')">
												{{ errors.first('class_id') }}
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 text-right">
											<ts-button class="btn-block" color="primary" @click.prevent="preview" :waiting="waiting">{{
												$t('preview') }}</ts-button>
										</div>
									</div>
								</fieldset>
							</form>
						</ts-loading-banner>
					</ts-card-wrapper>
				</ts-card>
			</div>
			<div class="col-md-9">
				<ts-card>
					<ts-card-wrapper>
						<form>
							<fieldset>
								<legend>{{ $t('partTimeOfMonthly.preview') }}</legend>
								<ts-preview-pdf v-model="waiting" :src="src" />
							</fieldset>
						</form>
					</ts-card-wrapper>
				</ts-card>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
	name: 'partTimeOfMonthly',
	data() {
		return {
			loading: false,
			waiting: false,
			fetching_academic_year: false,
			fetching_academic_term: false,
			fetching_class_operation: false,
			src: '',
			errors: new Errors(),
			branches: [],
			classes: [],
			main_programs: [],
			sub_programs: [],
			ac_terms: [],
			ac_year_list: [],
			scoringCycleValue: [],
			model: {
				branch_id: null,
				class_id: null,
				ac_year_id: null,
				ac_term_id: null,
				acp_id: null,
				acps_id: null,
				cycle_value: null
			}
		}
	},
	computed: {
		...mapState('reportAcademic', ['studentStatus']),
		status() {
			return this.studentStatus.filter(s => s.status_id !== 1)
		}
	},
	created() {
		this.fetchData()
	},
	methods: {
		...mapActions('reportAcademic', [
			'getBranch',
			'getStudentPofile',
			'getClass',
			'getMainProgram',
			'getSubProgram',
			'getTerm',
			'getYear',
			'getScoringCycleValue',
			'partTimeOfMonthly'
		]),
		async fetchData() {
			this.loading = true
			await this.getBranch().then(response => {
				this.branches = response.data.map(el => ({
					value: el.branch_id,
					label: el.branch_name_en
				}))
				this.model.branch_id = this.$store.state.authUser.default_branch_id
			})
			await this.getMainProgram()
				.then(response => {
					this.main_programs = response.data
						.filter(mp => mp.acp_id == 103)
						.map(el => ({
							value: el.acp_id,
							label: el.acp_name_foreign
						}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
			await this.getScoringCycleValue()
				.then(response => {
					this.scoringCycleValue = response.data
						.filter(mp => mp.scoring_cycle_id == 1)
						.map(el => ({
							value: el.scoring_cycle_value,
							label: el.scoring_cycle_description
						}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
					this.model.branch_id = this.$store.state.authUser.default_branch_id
				})
			this.loading = false
		},
		async onMainProgramChange(acp_id) {
			this.model.acps_id = null
			await this.getSubProgram({
				filter: {
					acp_id: acp_id
				}
			})
				.then(response => {
					this.sub_programs = response.data
						.map(el => ({
							value: el.acps_id,
							label: el.acps_name_foreign
						}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onSubChange(acps_id) {
			this.model.ac_term_id = null
			this.model.class_id = null
			if (this.model.ac_year_id) {
				this.fetching_academic_term = true
				this.getTerm({
					filter: {
						acps_id: acps_id,
						ac_status_id: '1,2,3',
						ac_year_id: this.model.ac_year_id,
						branch_id: this.model.branch_id
					},
					branch_id: [this.model.branch_id]
				})
					.then(response => {
						this.ac_terms = response.data.map(el => ({
							value: el.ac_term_id,
							term_order: el.term_order,
							label:
								el.term_name +
								(el.ac_status_id == 1
									? ' ( Current ) '
									: el.ac_status_id == 2
										? ' ( History ) '
										: '( Next )')
						}))
					})
					.catch(error => {
						this.$toasted.error(error.message)
					})
					.finally(() => {
						this.fetching_academic_term = false
					})
			}
		},
		onBranchChange() {
			this.model.ac_year_id = null
			this.model.acps_id = null
			this.model.ac_term_id = null
			this.fetching_academic_year = true
			this.getYear({
				filter: {
					ac_status_id: '1,2,3',
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
						el => ({
							value: el.ac_year_id,
							label:
								el.ac_year +
								(el.ac_status_id == 1
									? ' ( Current ) '
									: el.ac_status_id == 2
										? ' ( History ) '
										: ' ( Next ) ')
						})
					)
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.fetching_academic_year = false
				})
		},
		acYearChange() {
			this.model.ac_term_id = null
			this.model.class_id = null
			this.fetching_academic_term = true
			this.getTerm({
				filter: {
					acps_id: this.model.acps_id,
					ac_status_id: '1,2,3',
					ac_year_id: this.model.ac_year_id,
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.ac_terms = response.data.map(el => ({
						value: el.ac_term_id,
						term_order: el.term_order,
						label:
							el.term_name +
							(el.ac_status_id == 1
								? ' ( Current ) '
								: el.ac_status_id == 2
									? ' ( History ) '
									: '( Next )')
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.fetching_academic_term = false
				})
		},
		acTermChange(ac_term_id) {
			this.fetching_class_operation = true
			this.model.class_id = null
			this.getClass({
				filter: {
					ac_term_id: ac_term_id,
					branch_id: this.model.branch_id
				},
				branch_id: [this.model.branch_id]
			})
				.then(response => {
					this.classes = response.data.map(el => ({
						value: el.class_id,
						label:
							el.class_name +
							' | ' +
							el.teacher.full_name_en +
							' | ' +
							el.academic_study_time.study_time,
						grade_id: el.grade_id
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.fetching_class_operation = false
				})
		},
		preview() {
			this.waiting = true
			this.src = ''
			this.errors = new Errors()
			this.partTimeOfMonthly({
				branch_id: this.model.branch_id,
				class_id: this.model.class_id,
				ac_year_id: this.model.ac_year_id,
				ac_term_id: this.model.ac_term_id,
				acp_id: this.model.acp_id,
				acps_id: this.model.acps_id,
				cycle_value: this.model.cycle_value
			})
				.then(response => {
					this.src = response.url
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		}
	},
	watch: {
		'model.branch_id': function (val) {
			if (val) {
				this.onBranchChange()
			}
		}
	}
}
</script>